<template>
    <div class="seminar-table">
        <div class="table-responsive table-shadow">
            <table class="table m-0">
                <thead>
                <tr>
                    <th style="min-width: 160px"> 開催日 </th>
                    <th style="min-width: 128px"> 開催時間 </th>
                    <th style="min-width: 256px"> 開催場所 </th>
                    <th style="min-width: 320px"> 内容 </th>
                </tr>
                </thead>
                <tbody>
                    <template v-if="!tableData.length  || tableData.length === 0">
                        <tr class="empty-data">
                            <td colspan="4" class="el-table__empty-text">データなし。</td>
                        </tr>
                    </template>
                    <template v-for="(data, index) in (tableData.slice((currentPage-1)*pageSize, currentPage*pageSize))">
                        <tr :key="index" :value="index" >
                            <td>
                                <div v-text="data.exhibitionDate"></div>
                                <el-button type="primary" class="gtm_seminar_sanka_seminar" v-show="!data.flag && isValidDate(data.exhibitionDate, data.exhibitionTime)" @click="handleJoin(data)"><span class="gtm_seminar_sanka_seminar">参加する</span></el-button>
                                <div v-show="data.flag && isValidDate(data.exhibitionDate, data.exhibitionTime)" class="thank-you-message">お申込みいただきありがとうございました。参加を取り消される場合は、以下ボタンより参加取消をしてください。</div>
                                <el-button style="margin-left: unset;" class="gtm_seminar_torikesi_seminar" v-show="data.flag && isValidDate(data.exhibitionDate, data.exhibitionTime)" @click="handleUnJoin(data)"><span class="gtm_seminar_torikesi_seminar">参加取消</span></el-button>
                                <el-button style="margin-left: unset;" v-show="data.flag && !isValidDate(data.exhibitionDate, data.exhibitionTime)">申込済み</el-button>
                            </td>
                            <td>
                                {{ data.exhibitionTime }}
                            </td>
                            <td style="text-align: left;">
                                <label v-if="data.url == null" v-html="getVenueHtml(data.venue)"/>
                                <el-link :href="data.url" target="_blank" v-else ><div v-html="getVenueHtml(data.venue)"/></el-link>
                            </td>
                            <td>
                                <div class="content" v-html="data.content"></div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="block " style="width: 100%; float: left" v-show="tableData.length > pageSize">
            <div class="block block-pagination">
                <el-pagination
                    type="local"
                    v-show="true"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[5, 10, 20, 50, 100]"
                    :pager-count="pageCount"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next"
                    :data="tableData"
                    :total="tableData.length">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'seminar-table',
  props: {
    data: Array,
    groupId: Number
  },
  watch: {
    data () {
      this.tableData = this.data
    }
  },
  mounted () {
      this.tableData = this.data
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      pageCount: isMobile ? 5 : 7
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    handleJoin (row) {
      localStorage.setItem('redirectSeminar', row.id)
      this.$emit('handleJoin', { ...row, groupId: this.groupId })
    },
    handleUnJoin (row) {
      this.$emit('handleUnJoin', row)
    },
    isValidDate (exhibitionDate, exhibitionTime) {
      if (exhibitionDate !== null) {
        let date = exhibitionDate.replace(/\D/g, '')
        date = date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2)
        // 参加、参加取消は前々日まで
        let tomorrow = moment().add(1, 'days').format('YYYY-MM-DD HH:mm')
        let exDate = moment(date).format('YYYY-MM-DD HH:mm')
        return exDate > tomorrow
      }
      return false
    },
    getVenueHtml (venue) {
        let venueAry = venue.split('　')
        let output = ''
        venueAry.forEach(element => {
            output = output + element + '<br>'
        })
        return output
    }
  }
}
</script>
<style>
    @import './seminar.css';
</style>
<style scoped>
    @import "../../../../assets/css/custom.css";
    table td .content {
        text-align: left;
    }
    .table-responsive tr td:first-child,
    .table-responsive tr th:first-child {
        border-left: unset;
    }
    .table-responsive tr th {
        border-top: unset;
    }
    .table-responsive tr td:last-child,
    .table-responsive th:last-child {
        border-right: unset;
    }
    .table-responsive tr:last-child td {
        border-bottom: unset;
    }
    .table-responsive {
        border: 1px solid #d6d6d6;
        border-radius: 10px;
    }
    table td .content img {
        width: 100%;
        height: 150px;
    }
    table .btn-delete {
        background-color: #d9534f;
        border-color: #d43f3a;
        border-radius: 5px;
        color: white;
        font-size: 18px;
        cursor: pointer;
    }
    table .note {
        margin-top: 10px;
        padding-left: 5px;
        margin-bottom: 10px;
    }
    table tr td a {
        color: #3a8ee6 !important;
    }
    table {
        width: 100%;
        margin: 1em auto;
        /*border: 2px solid #d6d6d6;*/
        border-collapse: separate !important;
        -webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
        -moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
        box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    }
    _:-ms-lang(x)::-ms-backdrop, table {
        table-layout: fixed;
    }
    table tr:first-child th:first-child {
        border-top-left-radius: 10px;
    }
    table tr:first-child th:last-child {
        border-top-right-radius: 10px;
    }
    table tr:last-child td:first-child {
        border-bottom-left-radius: 10px;
    }

    table tr:last-child td:last-child {
        border-bottom-right-radius: 10px;
    }
    .table td {
        border-left: 1px solid #d6d6d6;
        border-bottom: 1px solid #d6d6d6;
        text-align: center;
        padding: 1em;
        /*background: #e6f6fe;*/
        font-size: 14px;
        vertical-align: top;
    }
    .table .bg-blue td {
        background: #8edbff;
    }
    .table .bg-lightblue td {
        background: #e6f6fe;
    }
    .table th {
        border-left: 1px solid #d6d6d6;
        border-bottom: 1px solid #d6d6d6;
        text-align: center;
        background-color: #f7f0df;
        padding: 1em;
        font-size: 16px;
        font-weight: bold;
        color: #321007;
    }
    .table-responsive {
        border-radius: 10px;
    }
    table tr.empty-data td {
        padding: 0 !important;
    }
    .thank-you-message {
        font-size: 13px;
        margin-top: 8px;
        margin-bottom: 8px;
        text-align: left;
        line-height: 1.5;
    }
</style>
